export interface TaskSequenceSortable {
  id: string;
  sequenceNumber?: number | null;
}

export function sortTasksBySequenceNumber<T extends TaskSequenceSortable>(
  tasks: readonly T[] | null | undefined,
): T[] {
  if (!tasks?.length) return [];
  return [...tasks].sort((a, b) => {
    const seqA = a.sequenceNumber ?? Number.MAX_SAFE_INTEGER;
    const seqB = b.sequenceNumber ?? Number.MAX_SAFE_INTEGER;
    if (seqA !== seqB) return seqA - seqB;
    return a.id.localeCompare(b.id);
  });
}
